<div [class]="'esn-spatial-node esn-spatial-node--' + type()">
  <div class="esn-spatial-node__top">
    <span class="esn-spatial-node__label" [attr.title]="label()">{{ label() }}</span>
    @if (type() === 'root') {
      <span class="esn-spatial-node__live" aria-label="Live" role="img"></span>
    } @else if (type() === 'floor') {
      <button
        type="button"
        class="esn-spatial-node__toggle"
        [class.esn-spatial-node__toggle--collapsed]="!expanded()"
        [attr.aria-label]="expanded() ? 'Collapse' : 'Expand'"
        [attr.aria-expanded]="expanded()"
        (click)="expanded.set(!expanded())"
      >
        <esn-icon name="chevron-down" [size]="12" />
      </button>
    }
  </div>
  @if (subtitle(); as s) {
    <span class="esn-spatial-node__subtitle">{{ s }}</span>
  }
</div>
